import React, { useCallback } from 'react';

import { ReactThreeFiber } from 'react-three-fiber';
import { useTexture } from '../../../hooks';
import { Mesh, Geometry, BufferGeometry, Material } from 'three';
import { useGesture } from 'react-use-gesture';
import { isFunction } from 'lodash';
import Button from '../../../components/xr/button';
import storyCloseBtnIcon from '../../../assets/images/xr/icons/story-close.png';

const getGeometrySize = (img: HTMLImageElement) => {
  let width = 1;
  let height = 1;

  const imgWidth = img?.width || 1;
  const imgHeight = img?.height || 1;

  if (imgWidth >= imgHeight) {
    width = 1;
    height = imgHeight / imgWidth;
  } else {
    height = 1;
    width = imgWidth / imgHeight;
  }

  return [width, height];
};

type ZoomedImageProps = ReactThreeFiber.Object3DNode<
  Mesh<Geometry | BufferGeometry, Material | Material[]>,
  typeof Mesh
> & {
  src: string;
  width?: number;
  height?: number;
  position?: ReactThreeFiber.Vector3;
  rotation?: ReactThreeFiber.Euler;
  onClose?: () => void;
};

const ZoomedImage = ({ src, position, rotation, onClose, ...props }: ZoomedImageProps) => {
  const { texture, loaded } = useTexture(src);
  const { texture: btnStoryCloseTxt } = useTexture(storyCloseBtnIcon);

  const bind = useGesture({
    onClick: ({ event }) => {
      const evt = event as any;
      evt.nativeEvent.preventDefault();
      evt.nativeEvent.stopPropagation();
event.stopPropagation();
    },
    onHover: ({ event }) => {
      const evt = event as any;
      evt.nativeEvent.preventDefault();
      evt.nativeEvent.stopPropagation();
event.stopPropagation();
    },
  });

  const handleClose = useCallback(() => {
    if (isFunction(onClose)) {
      onClose();
    }
  }, [onClose]);

  const size = 0.03;

  const [width, height] = getGeometrySize(texture.image);

  return loaded ? (
    <mesh position={position} rotation={rotation} {...props} {...bind()}>
      <planeBufferGeometry args={[width, height]} attach="geometry" />
      <meshBasicMaterial attach="material" map={texture} transparent={true} />

      <Button
        onClick={handleClose}
        position={[width / 2 + size / 2, height / 2 + size / 2, 0.001]}
        defaultState={{
          main: { geometry: 'circle', size, material: { transparent: true, opacity: 0.8, color: '#40A9E5' } },
          icon: { size: size - 0.005, material: { transparent: true, map: btnStoryCloseTxt } },
        }}
      />
    </mesh>
  ) : null;
};

export default ZoomedImage;
